// removed by extract-text-webpack-plugin
module.exports = {"title":"_1TRY8-PTPOSqteOiYmC2Er","buttonNew":"_3mUo4qgDrv9pl_zrlCNbgP","buttonMove":"a0IyIUDKCWx_tH6OxCCr9","buttonVerify":"_3qORmRoQWWeudq1DwKf-Np","searchField":"Jvkd5o_o5hKPuZdfzyHRo","table":"_1ilAkr7PO5f2TXd5siBwOg","image":"_1mk0O_9NW7wZZMFCuV69mi","spinner":"_1IcIVCy0HMoc6erm3wQZRW","buttonLoadMore":"_3-L1kQXJMduUGFKFvcZnIB"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Articles/style.scss
// module id = 1242
// module chunks = 0